export const REGEX_TIMESTRING_MM_SS_T = /^([0-5][0-9]):([0-5][0-9])\.([0-9])$/; 
export const REGEX_TIMESTRING_HHHH_MM_SS = /^\d{4}:[0-5][0-9]:[0-5][0-9]$/;
export const REGEX_TIMESTRING_HH_MM_SS = /^([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;